import { render } from "./CardPhoto.vue?vue&type=template&id=516e3cf2&scoped=true"
import script from "./CardPhoto.vue?vue&type=script&lang=js"
export * from "./CardPhoto.vue?vue&type=script&lang=js"

import "./CardPhoto.vue?vue&type=style&index=0&id=516e3cf2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516e3cf2"]])

export default __exports__